import { Beneficiaries } from "redux/constants/Beneficiaries";

const initState = {
  data: [],
  loading: false,
};

const beneficiaries = (state = initState, action) => {
  switch (action.type) {
    case Beneficiaries.LOADING_BENEFICIARIES_LIST:
      return {
        ...state,
        loading: action.payload,
      };
    case Beneficiaries.GET_BENEFICIARIES_LIST:
      return {
        ...state,
        data: action.payload,
      };
    default:
      return state;
  }
};

export default beneficiaries;